import {
    ADULT,
    AUTH_DENIED,
    SUCCEED,
} from "constant/ucc.thumb.type";
import React, { useState, useMemo } from "react";
import { Trans } from "react-i18next";

const CatchStoryHiddenImage = ({ vod, storyHiddenInfo }) => {
    const {thumbType} = vod.thumb_type;
    const [imgError, setImgError] = useState(false);

    const handleVodImageError = (e) => {
        setImgError(true);
    };

    const thumbnail = useMemo(() => {

        if(vod.resolution_type === 'vertical'){
            {/*모바일 홈 > 세로형 캐치*/}
            return (
                <div className="thumb">
                    <img src={vod.thumb} alt="" onError={handleVodImageError} loading="lazy" />
                    <div className="story_num">
                        <em>{storyHiddenInfo.catch_cnt}</em>
                    </div>
                </div>
            );
        }
        
        if(vod.resolution_type === 'horizontal'){
            {/*모바일 홈 > 가로형 캐치*/}
            return (
                <div className="thumb thumb_16_9" style={{ margin: "20px auto" }}>
                    <div className="thumb_16_9_area">
                        <img src={vod.thumb_h} alt="" onError={handleVodImageError} loading="lazy" />
                        <div className="thumb_blur">
                            <img src={vod.thumb} alt="" loading="lazy" />
                        </div>
                    </div>
                    <div className="story_num">
                        <em>{storyHiddenInfo.catch_cnt}</em>
                    </div>
                </div>
            );
        }
	}, []);

    switch (thumbType) {
        // 권한 없는 게시글
        case AUTH_DENIED:
            return (
                <div className="thumb thumb-default">
                    <div className="story_num">
                        <em>{storyHiddenInfo.catch_cnt}</em>
                    </div>
                </div>
            );

        // 성인 영상
        case ADULT:
            return (
                <span className="thumb-adult">
                    <Trans>19금</Trans>
                    <div className="story_num">
                        <em>{storyHiddenInfo.catch_cnt}</em>
                    </div>
                </span>
            );

        // 완료 - 썸네일 노출
        case SUCCEED:
        default:
            if (imgError) {
                return (
                    <div className="thumb thumb-default">
                        <div className="story_num">
                            <em>{storyHiddenInfo.catch_cnt}</em>
                        </div>
                    </div>
                );
            } else { 
                return thumbnail
            }
    }
};

export default CatchStoryHiddenImage;
